module.exports = __webpack_public_path__ + "f0cc1e85133e1cfbb25e77ddeac69565.svg";